export default "__VITE_ASSET__CWDh$Mof__"